import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { ComboboxLoading, ComboboxOptions, ComboboxOptionsProps } from '@anyui/core';
import { useSelectContext } from '../select-context';
import { SelectEmpty } from './select-empty';
import { SelectCreateOption } from './select-create-option';

export const SelectMenu = ({ children, className, ...restProps }: ComboboxOptionsProps) => {
  const { t } = useTranslation();
  const {
    selectProps: { loading, classNames, showAllOptions, loadingMessage }
  } = useSelectContext();

  return (
    <ComboboxOptions
      className={cn(
        'mt-0',
        // TODO: SelectAll option styles - Combobox.Option className is passing into child instead of root element so we need to use attribute selector to target it
        '[&_[data-slot="combobox-option"][data-value="select-all"]]:sticky',
        '[&_[data-slot="combobox-option"][data-value="select-all"]]:top-0',
        '[&_[data-slot="combobox-option"][data-value="select-all"]]:z-1',
        `[&_[data-slot="combobox-option"][data-value="select-all"]]:-order-1`,
        `[&_[data-slot="combobox-option"][data-value="select-all"]]:bg-white`,
        `[&_[data-slot="combobox-option"][data-value="select-all"]]:hover:bg-zinc-50`,
        { 'max-h-max': showAllOptions },
        className,
        classNames?.menu
      )}
      {...restProps}
    >
      {loading ? (
        <ComboboxLoading className="order-1 col-start-2">{loadingMessage || t('Searching...')}</ComboboxLoading>
      ) : null}
      {/* We cannot use Fragment for else condition above - issue: Cannot use 'in' operator to search for 'render' in Symbol(react.fragment) */}
      {!loading ? (
        <>
          {children}
          <SelectEmpty />
          <SelectCreateOption />
        </>
      ) : null}
    </ComboboxOptions>
  );
};
